import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../../authConfig";
import { InteractionStatus } from "@azure/msal-browser";
import { useError } from "../../../Events/UI/ErrorContext";

const useFetchMsal = (): ((method: string, url: string, data?: any, signal?: AbortSignal) => Promise<any>) => {
  const { setError } = useError();
  const { instance, inProgress } = useMsal();
  return (method, url, data, signal) => {
    const promise = new Promise(function (myResolve, myReject) {
      if (inProgress === InteractionStatus.None) {
        instance
          .acquireTokenSilent({
            ...loginRequest,
            account: instance.getActiveAccount() ?? undefined,
          })
          .then((accessTokenResponse) => {
            let accessToken = accessTokenResponse.accessToken;

            // Call your API with token
            const headers = new Headers();
            const bearer = `Bearer ${accessToken}`;
            headers.append("Authorization", bearer);

            let options = {
              method: method,
              headers: headers,
              body: data ? JSON.stringify(data) : null,
              signal: signal,
            };

            fetch(url, options)
              .then(async (value) => {
                if (value.ok === false) {
                  var res = await value.text();
                  setError(`Backend error ${res}`);
                  myReject(res);
                } else {
                  var resp = await value.json();
                  myResolve(resp);
                }
              })
              .catch((error) => {
                setError(error);
                myReject(error);
              });
          })
          .catch((error) => {
            setError(error);
            myReject(error);
          });
      } else {
        setError("Previous interaction in progress.");
        myReject("Previous interaction in progress.");
      }
    });

    return promise;
  };
};

export default useFetchMsal;
